import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      backgroundColor: '#f8fafc',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        padding: '48px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px'
          }}>
            <img
              src="/execdash_logo.png"
              alt="ExecDash Logo"
              style={{
                height: '48px',
                width: 'auto'
              }}
            />
          </div>
          <h1 style={{
            fontSize: '36px',
            fontWeight: 300,
            color: '#1a202c',
            margin: '0 0 16px 0',
            fontFamily: 'Raleway, sans-serif'
          }}>
            Privacy Policy
          </h1>
          <p style={{
            color: '#718096',
            fontSize: '16px',
            margin: 0
          }}>
            Last updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* Content */}
        <div style={{
          lineHeight: '1.7',
          color: '#2d3748',
          fontSize: '16px'
        }}>
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              1. Introduction
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Execdash ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our executive dashboard platform and related services (the "Service").
            </p>
            <p style={{ marginBottom: '16px' }}>
              By using our Service, you consent to the data practices described in this policy. If you do not agree with the practices described in this policy, please do not use our Service.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              2. Information We Collect
            </h2>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 600,
              color: '#2d3748',
              marginBottom: '12px'
            }}>
              Personal Information
            </h3>
            <p style={{ marginBottom: '16px' }}>
              We may collect personal information that you provide directly to us, including:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Name and email address</li>
              <li style={{ marginBottom: '8px' }}>Organization name</li>
              <li style={{ marginBottom: '8px' }}>Account credentials and authentication information</li>
            </ul>

            <h3 style={{
              fontSize: '20px',
              fontWeight: 600,
              color: '#2d3748',
              marginBottom: '12px'
            }}>
              Business Data
            </h3>
            <p style={{ marginBottom: '16px' }}>
              When you connect your business systems to our Service, we may collect:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Development metrics and project data</li>
              <li style={{ marginBottom: '8px' }}>Support ticket information and customer service metrics</li>
              <li style={{ marginBottom: '8px' }}>Integration configuration and API credentials</li>
            </ul>
            
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              3. How We Use Your Information
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We use the information we collect to:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Provide, maintain, and improve our Service</li>
              <li style={{ marginBottom: '8px' }}>Generate AI-powered insights and analytics</li>
              <li style={{ marginBottom: '8px' }}>Authenticate users and maintain account security</li>
              <li style={{ marginBottom: '8px' }}>Process transactions and manage subscriptions</li>
              <li style={{ marginBottom: '8px' }}>Communicate with you about the Service</li>
              <li style={{ marginBottom: '8px' }}>Provide customer support and technical assistance</li>
              <li style={{ marginBottom: '8px' }}>Comply with legal obligations and protect our rights</li>
              <li style={{ marginBottom: '8px' }}>Improve our algorithms and develop new features</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              4. Information Sharing and Disclosure
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We do not sell, trade, or rent your personal information to third parties
            </p>            
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              5. Data Security
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We implement industry-standard security measures to protect your information:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Encryption in transit and at rest</li>
              <li style={{ marginBottom: '8px' }}>Regular security assessments and audits</li>
              <li style={{ marginBottom: '8px' }}>Access controls and authentication mechanisms</li>
              <li style={{ marginBottom: '8px' }}>Secure cloud infrastructure and data centers</li>
              <li style={{ marginBottom: '8px' }}>Employee training on data protection practices</li>
            </ul>           
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              6. Data Retention
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We retain your information for as long as necessary to provide our Service and fulfill the purposes outlined in this policy. Specific retention periods include:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Account information: Until account deletion or 3 years after last activity</li>
              <li style={{ marginBottom: '8px' }}>Business data: As configured by your plan's retention settings, or until your plan expires</li>
              <li style={{ marginBottom: '8px' }}>Usage logs: Up to 2 years for security and analytics purposes</li>
              <li style={{ marginBottom: '8px' }}>Support communications: Up to 3 years for quality assurance</li>
              <li style={{ marginBottom: '8px' }}>After each data synchronisation, all data used in computing aggregations is deleted from our servers, leaving only the data you see in the application.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              7. Your Rights and Choices
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Depending on your location, you may have the following rights regarding your personal information:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Access and review your personal information</li>
              <li style={{ marginBottom: '8px' }}>Correct inaccurate or incomplete information</li>
              <li style={{ marginBottom: '8px' }}>Delete your personal information (subject to legal requirements)</li>
              <li style={{ marginBottom: '8px' }}>Restrict or object to processing of your information</li>
              <li style={{ marginBottom: '8px' }}>Data portability for information you provided</li>
              <li style={{ marginBottom: '8px' }}>Withdraw consent where processing is based on consent</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              To exercise these rights, please contact us at support@execdash.ai.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              8. Cookies and Tracking Technologies
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We use cookies and similar tracking technologies to enhance your experience:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Essential cookies for Service functionality</li>
              <li style={{ marginBottom: '8px' }}>Analytics cookies to understand usage patterns</li>
              <li style={{ marginBottom: '8px' }}>Preference cookies to remember your settings</li>
              <li style={{ marginBottom: '8px' }}>Security cookies to protect against fraud</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              You can control cookie preferences through your browser settings, though some features may not function properly if cookies are disabled.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              9. International Data Transfers
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Our Service operates globally, and your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for international transfers, including:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Standard contractual clauses approved by regulatory authorities</li>
              <li style={{ marginBottom: '8px' }}>Adequacy decisions for certain jurisdictions</li>
              <li style={{ marginBottom: '8px' }}>Certification under recognized privacy frameworks</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              10. Children's Privacy
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Our Service is not intended for children under 16 years of age. We do not knowingly collect personal information from children under 16. If we become aware that we have collected personal information from a child under 16, we will take steps to delete such information.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              11. Changes to This Privacy Policy
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We may update this Privacy Policy from time to time. We will notify you of any material changes by:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Posting the updated policy on our website</li>
              <li style={{ marginBottom: '8px' }}>Sending email notifications to registered users</li>
              <li style={{ marginBottom: '8px' }}>Displaying prominent notices within the Service</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              Your continued use of the Service after such modifications constitutes acceptance of the updated Privacy Policy.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              12. Contact Us
            </h2>
            <p style={{ marginBottom: '16px' }}>
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>Email:</strong> support@execdash.ai
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>Data Protection Officer:</strong> support@execdash.ai
            </p>
            <p style={{ marginBottom: '16px' }}>
              <strong>Address:</strong> execdash Privacy Team
            </p>
          </section>
        </div>

        
      </div>
    </div>
  );
};

export default PrivacyPolicy;
